import EcoSpace from 'eco-design/base/eco-space';
import BannerB2 from '../../components/BannerB/BannerB2';
import EcoAi from '../../components/EcoAi';
import Engineering from '../../components/Engineering';
import FooterTcA from '../../components/FooterTcA';
// import HighlightsB2 from '../../components/HighlightsB/HighlightsB2';
import ProductBundle from '../../components/ProductBundle';
import Plug from '../../components/Plug';
import PowerOceanA from '../../components/PowerOceanA';
// import ProductContrast from '../../components/ProductContrast';
// import ProductListStatusB from '../../components/ProductListStatusB';
import SeamLess from '../../components/SeamLess';
// import StepPortal from '../../components/StepPortal';
import OnlineStoreRightsAcPro from '../../components/OnlineStoreRightsAcPro';
import InputPowerAcPro from '../../components/InputPowerAcPro';
import SectionA3 from '../../components/SectionA3';
import Essentials from '../../components/Essentials';
import SectionB1 from '../../components/SectionB1';
import SectionB2 from '../../components/SectionB2';
import AllMicroInverters from '../../components/AllMicroInverters';
// import Certification from '../../components/Certification';
import DriveBills from '../../components/DriveBills';
import Assistant from '../../components/Assistant';
import SolarPowerV2 from '../../components/SolarPower-V2';
import { useRouter } from 'next/router';
import SectionListGraph from '../components/SectionListGraph';
import SectionGraphCompare from '../components/SectionGraphCompare';
import SectionCompare from '../components/SectionCompare';

export default function StatusItem() {
    const { locale = 'eu' } = useRouter();

    return (
        <>
            <BannerB2 />
            <EcoSpace hPc="160px" />
            <OnlineStoreRightsAcPro productName="AcPro" />
            <div className="product-box">
                {/* <ProductListStatusB type="ac" /> */}
                <EcoSpace hPc="160px" />
                <ProductBundle />
                <EcoSpace hPc="160px" />
                <DriveBills pageType="ac" />
                <AllMicroInverters />
                <InputPowerAcPro productName="ac" />
                <SectionListGraph />
                <SectionGraphCompare />
                <SectionA3 pageType="ac" />
                <SolarPowerV2 />
                <Essentials pageType="ac" />
                {locale !== 'uk' && <Plug pageType="normal" />}
                {/* <EcoSpace hPc="120px" />
                <StreamSystems /> */}
                {/* <MixInput /> */}
                {/* <ScalableCapacity /> */}

                <SectionB1 pageType="ac" />
                <SectionB2 pageType="ac" />
                {/* <SolarIndoors /> */}
                {/* <SolarLiving /> */}
                <div style={{ background: '#000' }}>
                    <EcoAi pageType="ac" />
                    <SeamLess pageType="ac" />
                    <Assistant pageType="ac" />
                </div>
                <Engineering />
                {/* <ProductContrast /> */}
                <EcoSpace hPc="160px" />
                {/* <Certification /> */}
                <SectionCompare />
                <EcoSpace hPc="160px" hPad="100px" />
                <PowerOceanA productName="AcPro" />
                <EcoSpace hPc="160px" />
                <FooterTcA pageType="ac" />
            </div>
        </>
    );
}
